import {Link } from 'react-router-dom'
import './error.css'

function Error(){
    return(
        <div className='containererror'>
          <h1 className='tituloerro'>404</h1>
          <h2 className='subtitulo'>Pagina não encontrada!</h2>
          <Link to="/" className='linkretorno'>Veja todos os filmes!</Link>
        </div>
    )
}
export default Error;